var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, IconButton, Popover, TextField } from '@mui/material';
import { HexColorPicker } from 'react-colorful';
import { useTranslation } from "react-i18next";
var CColorPicker = function (_a) {
    var value = _a.value, onChange = _a.onChange, sx = _a.sx, size = _a.size, disabled = _a.disabled;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var t = useTranslation().t;
    var handleColorPickerClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'color-picker-popover' : undefined;
    return (_jsxs(Box, __assign({ sx: __assign({ display: 'flex', alignItems: 'center', width: '100%' }, sx) }, { children: [_jsx(TextField, { label: t("Color"), variant: "outlined", value: value || '', onChange: function (e) { return onChange(e.target.value); }, InputProps: {
                    endAdornment: (_jsx(IconButton, __assign({ onClick: handleColorPickerClick, "aria-describedby": id, disabled: disabled }, { children: _jsx("div", { style: {
                                width: 24,
                                height: 24,
                                backgroundColor: value || '#ffffff',
                                border: '1px solid #ccc',
                                opacity: disabled ? 0.5 : 1
                            } }) })))
                }, sx: {
                    width: '100%'
                }, size: size, disabled: disabled }), _jsx(Popover, __assign({ id: id, open: !disabled && open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, sx: {
                    '& .MuiPopover-paper': {
                        padding: '24px'
                    }
                } }, { children: _jsx(HexColorPicker, { color: value || '#ffffff', onChange: onChange }) }))] })));
};
export default CColorPicker;
